let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8PrU4")).then(() => parcelRequire('55Bec'));